import React, { SVGProps } from 'react';

export const OrganizerSeatIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    {...props}
  >
    <path
      opacity="0.4"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19002 8.926H6.81062C4.36731 8.926 3.50067 10.7073 3.50067 12.2327C3.50067 13.5873 4.25466 14.3327 5.62266 14.3327H10.3787C11.7467 14.3327 12.5007 13.5867 12.5007 12.2327C12.5 10.708 11.6334 8.926 9.19002 8.926Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.0054 7.67467C9.30006 7.67467 10.3527 6.62599 10.3527 5.33732C10.3527 4.04799 9.2994 3 8.0054 3C6.7114 3 5.65869 4.04865 5.65869 5.33732C5.65869 6.62599 6.71073 7.67467 8.0054 7.67467Z"
    />
    <path
      opacity="0.4"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8.43334C15 9.47334 14.4266 10.0466 13.38 10.0466H13.1C13.0134 10.0466 12.9466 10 12.9133 9.92667C12.4266 9.04667 11.6067 8.35334 10.4267 8.07334C10.2734 8.03334 10.2066 7.84667 10.32 7.74C10.78 7.30667 11.1134 6.74 11.26 6.10669C11.28 6.02002 11.36 5.95337 11.4534 5.95337H12.5267C14.3534 5.95337 15 7.29334 15 8.43334Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4534 3.4467C13.4534 4.43336 12.6534 5.23332 11.6734 5.23332C11.624 5.23332 11.5754 5.23065 11.528 5.22665C11.4667 5.22132 11.4214 5.20137 11.3908 5.1687C11.3601 5.13604 11.3428 5.1047 11.3388 5.05404C11.2674 4.15337 10.8321 3.35664 10.1794 2.80664C10.1388 2.77198 10.1187 2.74868 10.1087 2.70468C10.0994 2.66268 10.098 2.61466 10.1227 2.56999C10.428 2.03066 11.008 1.66602 11.6734 1.66602C12.6534 1.66668 13.4534 2.4667 13.4534 3.4467Z"
    />
    <path
      opacity="0.4"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8.43334C1 9.47334 1.57337 10.0466 2.62003 10.0466H2.89999C2.98665 10.0466 3.05333 10 3.08667 9.92667C3.57333 9.04667 4.39333 8.35334 5.57333 8.07334C5.72666 8.03334 5.79335 7.84667 5.68001 7.74C5.22001 7.30667 4.88666 6.74 4.73999 6.10669C4.71999 6.02002 4.63997 5.95337 4.54663 5.95337H3.47331C1.64664 5.95337 1 7.29334 1 8.43334Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.54663 3.4467C2.54663 4.43336 3.34666 5.23332 4.32666 5.23332C4.37599 5.23332 4.42467 5.23065 4.472 5.22665C4.53334 5.22132 4.57862 5.20137 4.60929 5.1687C4.63996 5.13604 4.65729 5.1047 4.66129 5.05404C4.73262 4.15337 5.16797 3.35664 5.82064 2.80664C5.8613 2.77198 5.88136 2.74868 5.89136 2.70468C5.90069 2.66268 5.90202 2.61466 5.87736 2.56999C5.57202 2.03066 4.99199 1.66602 4.32666 1.66602C3.34666 1.66668 2.54663 2.4667 2.54663 3.4467Z"
    />
  </svg>
);
